import React from "react";
import {
  Button,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Locale from "../../../locales";
import {
  piecesStatuses,
  pieceStatusText,
} from "../../../constants/piecesStatuses";
import "./styles.css";

const useStyles = makeStyles({
  updateButton: {
    height: "50px",
    fontSize: "1rem",
  },
  closeButton: {
    height: "50px",
    fontSize: "1rem",
  },
  selectStatusContainer: {
    width: "100%",
  },
});

const UpdateDialog = ({
  updateDialogOpen,
  handleUpdateDialogClose,
  changeStatusHandler,
  setPreviousStatus,
  newStatus,
  setNewStatus,
}) => {
  const styles = useStyles();

  const handleStatusChange = (event) => {
    setPreviousStatus(newStatus);
    setNewStatus(event.target.value);
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();
    changeStatusHandler();
  };

  return (
    <>
      <Dialog open={updateDialogOpen} onClose={handleUpdateDialogClose}>
        <div className="update-dialog-container">
          <div className="update-dialog-header">
            <h2>{Locale.t("update_status")}</h2>
          </div>
          <div className="update-dialog-body">
            <form onSubmit={formSubmitHandler}>
              <div>
                <FormControl required className={styles.selectStatusContainer}>
                  <InputLabel id="select_status">
                    {Locale.t("select_status")}
                  </InputLabel>
                  <Select
                    labelId="select-label"
                    id="select_status"
                    value={newStatus}
                    label={Locale.t("select_status")}
                    onChange={handleStatusChange}>
                    {piecesStatuses.slice(1).map((el) => (
                      <MenuItem key={el} value={el}>
                        {pieceStatusText[el]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="update-dialog-form-controls">
                <div className="update-dialog-close-button">
                  <Button
                    className={styles.closeButton}
                    onClick={handleUpdateDialogClose}
                    variant="contained"
                    color="error">
                    {Locale.t("cancel")}
                  </Button>
                </div>
                <div className="update-dialog-sucess-button">
                  <Button
                    className={styles.updateButton}
                    type="submit"
                    variant="contained"
                    color="success">
                    {Locale.t("update")}
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default UpdateDialog;
